import React from 'react';
import { Gradient } from '../Gradient';

const Ratings = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M6.86352 2.04706H1.44629M4.36326 11.2147H1.44629M3.11313 7.04758H1.44629M13.7204 9.58952L14.4553 11.5C14.7533 12.275 13.8587 12.9616 13.1872 12.4732L11.5943 11.3148C11.0098 10.8897 10.218 10.8897 9.6335 11.3148L8.04061 12.4732C7.36913 12.9616 6.47448 12.275 6.77255 11.5L7.50738 9.58952C7.77828 8.88522 7.54222 8.08678 6.9319 7.64301L5.18638 6.37381C4.53352 5.89911 4.86931 4.86633 5.6765 4.86633H7.58262C8.31005 4.86633 8.95346 4.3946 9.17227 3.70086L9.81908 1.65011C10.0641 0.873138 11.1637 0.873141 11.4087 1.65011L12.0555 3.70086C12.2743 4.3946 12.9178 4.86633 13.6452 4.86633H15.5513C16.3585 4.86633 16.6943 5.89911 16.0414 6.37381L14.2959 7.64301C13.6856 8.08678 13.4495 8.88522 13.7204 9.58952Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>


  );
};

export default Ratings;